// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"125":"41736f09","677":"5a87bdf6","755":"44da67ef","918":"baa4151d","966":"42a6d894"}[chunkId] + ".js";
};